














import { defineComponent, computed, PropType } from '@vue/composition-api'

export default defineComponent({
  props: {
    name: String,
    label: String,
    errors: Object as PropType<Record<string, string[]>>
  },

  setup(props) {
    const fieldErrors = computed(() => props.errors?.[props.name ?? ''])

    return {
      fieldErrors
    }
  }
})
